export default "__VITE_ASSET___$U82PZI__"